import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import AppRouter, { history } from "./routers/AppRouter"
import configureStore from "./store/configureStore"
import { startSetExpenses, startAddExpense } from "./actions/expenses"
import { startSetGlobalLabels, startSetLabels } from "./actions/labels"
import { startSetAccounts } from "./actions/accounts"
import { startSetPermissions } from "./actions/permissions"
import { login, logout } from "./actions/auth"
import getVisibleExpenses from "./selectors/expenses"
import "normalize.css/normalize.css"
import "./styles/styles.scss"
import "react-dates/lib/css/_datepicker.css"
import { firebase } from "./firebase/firebase"
import LoadingPage from "./components/LoadingPage"

const store = configureStore()

//store.dispatch(addExpense({ description: 'Water bill', amount: 4500 }));
//store.dispatch(addExpense({ description: 'Gas bill', createdAt: 1000 }));
//store.dispatch(addExpense({ description: 'Rent', amount: 109500 }));

const state = store.getState()
const visibleExpenses = getVisibleExpenses(state.expenses, state.filters)
//console.log(visibleExpenses);

const jsx = (
  <Provider store={store}>
    <AppRouter />
  </Provider>
)

let hasRendered = false
const renderApp = () => {
  if (!hasRendered) {
    ReactDOM.render(jsx, document.getElementById("app"))
    hasRendered = true
  }
}

ReactDOM.render(<LoadingPage />, document.getElementById("app"))

//const allowUpload = firebase.ref(`users/${uid}/permissions`)
//console.log("Permissions: ", allowUpload)

firebase.auth().onAuthStateChanged((user) => {
  //user.uid
  if (user) {
    const userProfile = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      authUID: user.uid,
      idToken: user.getIdToken(),
      isUserAdmin: user.email == "jeraldmjohnson@gmail.com" || user.email == "jmjohnson@jmjc.com" ? true : false,
    }
    // user.getIdToken().then((idToken) => {
    //   userProfile.idToken = idToken
    // })

    //console.log("user: ", user)
    store.dispatch(login(userProfile))
    store.dispatch(startSetPermissions())

    //store.dispatch(login(user.uid))

    // set labels from global/labels
    //store.dispatch(startSetGlobalLabels())

    // set labels from user defined labels
    store.dispatch(startSetLabels())
    store.dispatch(startSetAccounts())

    store.dispatch(startSetExpenses()).then(() => {
      renderApp()
      if (history.location.pathname === "/") {
        history.push("/dashboard")
      }
    })
  } else {
    store.dispatch(logout())
    renderApp()
    history.push("/")
  }
})



// WEBPACK FOOTER //
// ./src/app.js